import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";

// Lazy load the main App component for better performance
const App = lazy(() => import("./App.jsx"));

// Loading component shown during code splitting
const Loading = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    backgroundColor: '#030014',
    color: 'white',
    fontSize: '1.5rem'
  }}>
    Loading niti.ai...
  </div>
);

ReactDOM.render(
  <Router>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </Router>,
  document.getElementById("root")
);

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
